import React from 'react';

const Badge = ({ 
  children, 
  variant = 'default', 
  className = '',
  ...props 
}) => {
  const variants = {
    default: 'bg-primary/10 text-primary',
    secondary: 'bg-gray-200/60 dark:bg-gray-700 text-gray-700 dark:text-gray-300',
    success: 'bg-green-500/10 text-green-700 dark:text-green-400',
    highlight: 'bg-highlight text-highlight-text',
  };
  
  const baseStyles = 'rounded-full px-3 py-1 text-xs font-medium';
  const classes = `${baseStyles} ${variants[variant]} ${className}`;
  
  return (
    <span className={classes} {...props}>
      {children}
    </span>
  );
};

export default Badge;

